import * as React from 'react';
import { SVGProps } from 'react';

const SvgApiExplorerHome = (
  props: SVGProps<SVGSVGElement> & React.HTMLAttributes<HTMLElement>
) => (
  <svg
    width={371}
    height={118}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.25}>
      <mask
        id="api-explorer-home_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={1}
        width={55}
        height={55}
      >
        <circle
          cx={29.21}
          cy={28.287}
          r={27.121}
          transform="rotate(45 29.21 28.287)"
          fill="#D9D9D9"
        />
      </mask>
      <g
        mask="url(#api-explorer-home_svg__a)"
        stroke="var(--core-surface-inverse-color)"
      >
        <path d="M31.008-8.27-7.347 30.085M35.353-3.925-3.002 34.43M39.698.42 1.343 38.775M44.044 4.765 5.688 43.12M48.388 9.11 10.033 47.465M52.733 13.455 14.378 51.81M57.078 17.8 18.723 56.155M61.423 22.145 23.068 60.5M65.768 26.49 27.413 64.844" />
      </g>
    </g>
    <g opacity={0.25}>
      <mask
        id="api-explorer-home_svg__b"
        maskUnits="userSpaceOnUse"
        x={64}
        y={1}
        width={55}
        height={55}
      >
        <circle
          cx={91.66}
          cy={28.287}
          r={27.121}
          transform="rotate(45 91.66 28.287)"
          fill="#D9D9D9"
        />
      </mask>
      <g
        mask="url(#api-explorer-home_svg__b)"
        stroke="var(--core-surface-inverse-color)"
      >
        <path d="M93.458-8.27 55.103 30.085M97.803-3.925 59.448 34.43M102.148.42 63.793 38.775M106.493 4.765 68.138 43.12M110.837 9.11 72.482 47.465M115.182 13.455 76.827 51.81M119.527 17.8 81.172 56.155M123.872 22.145 85.517 60.5M128.217 26.49 89.862 64.844" />
      </g>
    </g>
    <g opacity={0.25}>
      <mask
        id="api-explorer-home_svg__c"
        maskUnits="userSpaceOnUse"
        x={251}
        y={1}
        width={56}
        height={55}
      >
        <circle
          cx={279.01}
          cy={28.287}
          r={27.121}
          transform="rotate(45 279.01 28.287)"
          fill="#D9D9D9"
        />
      </mask>
      <g
        mask="url(#api-explorer-home_svg__c)"
        stroke="var(--core-surface-inverse-color)"
      >
        <path d="m280.809-8.27-38.356 38.355M285.153-3.925 246.798 34.43M289.499.42l-38.356 38.355M293.844 4.765 255.489 43.12M298.188 9.11l-38.355 38.355M302.534 13.455 264.179 51.81M306.878 17.8l-38.355 38.355M311.223 22.145 272.868 60.5M315.568 26.49l-38.355 38.355" />
      </g>
    </g>
    <g opacity={0.25}>
      <mask
        id="api-explorer-home_svg__d"
        maskUnits="userSpaceOnUse"
        x={64}
        y={63}
        width={55}
        height={55}
      >
        <circle
          cx={91.66}
          cy={90.737}
          r={27.121}
          transform="rotate(45 91.66 90.737)"
          fill="#D9D9D9"
        />
      </mask>
      <g
        mask="url(#api-explorer-home_svg__d)"
        stroke="var(--core-surface-inverse-color)"
      >
        <path d="M93.458 54.18 55.103 92.535M97.803 58.525 59.448 96.88M102.147 62.87l-38.355 38.355M106.493 67.215 68.138 105.57M110.837 71.56l-38.355 38.355M115.182 75.904 76.827 114.26M119.527 80.25l-38.355 38.355M123.872 84.594 85.517 122.95M128.217 88.94l-38.355 38.355" />
      </g>
    </g>
    <g opacity={0.25}>
      <mask
        id="api-explorer-home_svg__e"
        maskUnits="userSpaceOnUse"
        x={127}
        y={63}
        width={56}
        height={55}
      >
        <circle
          cx={155.002}
          cy={90.737}
          r={27.121}
          transform="rotate(45 155.002 90.737)"
          fill="#D9D9D9"
        />
      </mask>
      <g
        mask="url(#api-explorer-home_svg__e)"
        stroke="var(--core-surface-inverse-color)"
      >
        <path d="m156.801 54.18-38.355 38.355M161.146 58.525 122.79 96.88M165.49 62.87l-38.355 38.355M169.835 67.215 131.48 105.57M174.18 71.56l-38.355 38.355M178.525 75.905 140.17 114.26M182.87 80.25l-38.355 38.355M187.215 84.594 148.86 122.95M191.56 88.94l-38.355 38.355" />
      </g>
    </g>
    <g opacity={0.25}>
      <mask
        id="api-explorer-home_svg__f"
        maskUnits="userSpaceOnUse"
        x={315}
        y={63}
        width={55}
        height={55}
      >
        <circle
          cx={342.353}
          cy={90.737}
          r={27.121}
          transform="rotate(45 342.353 90.737)"
          fill="#D9D9D9"
        />
      </mask>
      <g
        mask="url(#api-explorer-home_svg__f)"
        stroke="var(--core-surface-inverse-color)"
      >
        <path d="m344.151 54.18-38.355 38.355M348.496 58.525 310.141 96.88M352.841 62.87l-38.355 38.355M357.186 67.215l-38.355 38.355M361.531 71.56l-38.355 38.355M365.875 75.904 327.52 114.26M370.221 80.25l-38.355 38.355M374.565 84.594 336.21 122.95M378.91 88.94l-38.355 38.355" />
      </g>
    </g>
    <path d="M0 0h371v118H0z" />
    <rect
      x={4.5}
      y={65.016}
      width={52.395}
      height={52.395}
      rx={26.197}
      stroke="var(--core-surface-inverse-color)"
    />
    <rect
      x={129.935}
      y={2.298}
      width={52.395}
      height={52.395}
      rx={26.197}
      stroke="var(--core-surface-inverse-color)"
    />
    <rect
      x={191.5}
      y={2.298}
      width={52.395}
      height={52.395}
      rx={26.197}
      stroke="var(--core-surface-inverse-color)"
    />
    <rect
      x={317.241}
      y={2.298}
      width={52.395}
      height={52.395}
      rx={26.197}
      stroke="var(--core-surface-inverse-color)"
    />
    <rect
      x={191.806}
      y={65.016}
      width={52.395}
      height={52.395}
      rx={26.197}
      stroke="var(--core-surface-inverse-color)"
    />
    <rect
      x={254.523}
      y={65.016}
      width={52.395}
      height={52.395}
      rx={26.197}
      stroke="var(--core-surface-inverse-color)"
    />
    <path
      d="M27.607 91.637a2.667 2.667 0 1 0 5.333 0 2.667 2.667 0 0 0-5.333 0Zm125.859-63.142a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0ZM30.273 92.137h2.066v-1h-2.066v1Zm6.198 0h4.132v-1H36.47v1Zm8.264 0h4.131v-1h-4.132v1Zm8.263 0h4.132v-1h-4.132v1Zm8.264 0h4.131v-1h-4.132v1Zm8.263 0h4.132v-1h-4.132v1Zm8.263 0h4.132v-1h-4.132v1Zm8.264 0h4.132v-1h-4.132v1Zm8.263 0h4.132v-1h-4.132v1Zm8.264 0h4.132v-1h-4.132v1Zm8.263 0h4.132v-1h-4.132v1Zm8.264 0h4.132v-1h-4.132v1Zm8.263 0h4.132v-1h-4.132v1Zm8.264 0h4.132v-1h-4.132v1Zm8.263 0h2.066v-1h-2.066v1Zm2.066 0c.712 0 1.408-.07 2.082-.203l-.194-.981c-.61.12-1.241.184-1.888.184v1Zm5.929-1.798a10.72 10.72 0 0 0 2.944-2.944l-.831-.556a9.72 9.72 0 0 1-2.669 2.67l.556.83Zm4.539-6.79c.133-.674.203-1.37.203-2.083h-1c0 .647-.064 1.278-.184 1.888l.981.194Zm.203-2.083v-1.891h-1v1.891h1Zm0-5.675v-3.784h-1v3.784h1Zm0-7.567V64.44h-1v3.784h1Zm0-7.568v-3.783h-1v3.783h1Zm0-7.567v-3.784h-1v3.784h1Zm0-7.567v-3.784h-1v3.784h1Zm0-7.567V34.17h-1v3.784h1Zm0-7.568v-1.892h-1v1.892h1ZM215.333 28.92a2.667 2.667 0 1 0 5.334-.001 2.667 2.667 0 0 0-5.334 0Zm0 62.717a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0Zm2.167-62.718v1.96h1v-1.96h-1Zm0 5.88v3.92h1v-3.92h-1Zm0 7.84v3.92h1v-3.92h-1Zm0 7.84v3.92h1v-3.92h-1Zm0 7.84v3.919h1v-3.92h-1Zm0 7.839v3.92h1v-3.92h-1Zm0 7.84v3.92h1v-3.92h-1Zm0 7.84v3.92h1v-3.92h-1Zm0 7.839v1.96h1v-1.96h-1ZM277.63 91.637a2.667 2.667 0 1 0 5.333 0 2.667 2.667 0 0 0-5.333 0Zm63.203-62.718a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0Zm-60.037 62.718V89.76h-1v1.877h1Zm0-5.63v-3.754h-1v3.754h1Zm0-7.507v-3.753h-1V78.5h1Zm0-7.507V67.24h-1v3.753h1Zm0-7.506v-3.754h-1v3.754h1Zm0-7.507v-3.754h-1v3.754h1Zm0-7.507V44.72h-1v3.753h1Zm0-7.507V39.09h-1v1.876h1Zm0-1.876c0-.647.064-1.278.184-1.888l-.981-.194c-.133.673-.203 1.37-.203 2.082h1Zm1.629-5.373a9.72 9.72 0 0 1 2.669-2.67l-.556-.83a10.72 10.72 0 0 0-2.944 2.944l.831.556Zm6.154-4.114a9.717 9.717 0 0 1 1.888-.184v-1c-.712 0-1.408.07-2.082.203l.194.981Zm1.888-.184h1.894v-1h-1.894v1Zm5.682 0h3.788v-1h-3.788v1Zm7.576 0h3.788v-1h-3.788v1Zm7.576 0h3.788v-1h-3.788v1Zm7.576 0h3.789v-1h-3.789v1Zm7.577 0h3.788v-1h-3.788v1Zm7.576 0h3.788v-1h-3.788v1Zm7.576 0h1.894v-1h-1.894v1Z"
      fill="var(--core-surface-inverse-color)"
    />
  </svg>
);
export default SvgApiExplorerHome;
